<app-compliance-tasks
  [columns]="columns"
  [isAssignedAssets]="true"
  [taskType]="tableTaskType"
  [data]="assignedAssets"
  [isLoading]="isLoading"
  [isLoadingMore]="isLoadingMore"
  [hasError]="hasError"
  (historyClicked)="onHistoryClick($event)"
  (editRequirementsClicked)="onEditRequirementsClick($event)"
  (editFrequencyClicked)="onEditFrequencyClick($event)"
  (deleteClicked)="onDeleteClick($event)"
  (scrolledDown)="onScrollDown()">
</app-compliance-tasks>